import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class CanManageUsersGuard implements CanActivate {
  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  public canActivate(): Observable<boolean> {
    return this._authService.user$.pipe(
      map(user => user.canManageRoles),
      tap(canActivate => {
        if (canActivate) {
          return;
        }

        this._router.navigate(['/']);
      })
    );
  }
}
